<template>
  <div>
    <notification v-for="notification of notifications" :key="notification.id" :notification="notification" />
  </div>
</template>

<script>
//---- components ---------
import Notification from "./Notification.vue"

export default {
  components: {
    Notification
  },
  computed: {
    notifications() {
      return this.$store.state.notifications.filter( x => !x.toast );
    },
  }
}
</script>